import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCarrierRegistrationService,
  CarrierRegistrationBoardModel,
  CarrierRegistrationBoardRequest,
  AdminCarrierListModel,
  AdminCarrierBoardSortRequest,
  PageModelAdminCarrierListModel,
  AdminCarrierListRequest
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCarrierRegistrationApiService {
  constructor(private apiService: AdministrationCarrierRegistrationService) {}

  public board(body: CarrierRegistrationBoardRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegistrationBoardModel[]> {
    return this.apiService.adminCarrierRegistrationBoard(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setBoardSort(body: AdminCarrierBoardSortRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminCarrierListModel> {
    return this.apiService.adminCarrierRegistrationEditBoardSortOrder(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public list(body: AdminCarrierListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAdminCarrierListModel> {
    return this.apiService.adminCarrierRegistrationList(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
